class FireflyBackToTop extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.button = this.querySelector('[data-back-to-top-button]');
    this.pageWrapper = document.querySelector('.page-wrapper');
    this.showAfter = Number(this.dataset.showAfter) || 300;
    this.isVisible = false;
    this.rafId = 0;

    if (!this.button) return;

    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.pageWrapper?.addEventListener('scroll', this.handleScroll, { passive: true });
    this.button.addEventListener('click', this.handleClick);

    this.updateVisibility();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    this.pageWrapper?.removeEventListener('scroll', this.handleScroll);
    this.button?.removeEventListener('click', this.handleClick);

    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  getScrollTop() {
    return Math.max(
      window.scrollY || 0,
      document.documentElement.scrollTop || 0,
      document.body.scrollTop || 0,
      document.scrollingElement?.scrollTop || 0,
      this.pageWrapper?.scrollTop || 0
    );
  }

  handleScroll() {
    if (this.rafId) return;

    this.rafId = requestAnimationFrame(() => {
      this.rafId = 0;
      this.updateVisibility();
    });
  }

  updateVisibility() {
    const scrollTop = this.getScrollTop();
    const shouldShow = this.isVisible ? scrollTop > 4 : scrollTop >= this.showAfter;

    if (shouldShow === this.isVisible) return;

    this.isVisible = shouldShow;
    this.classList.toggle('is-visible', shouldShow);
    this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    this.button.tabIndex = shouldShow ? 0 : -1;
  }

  handleClick() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduceMotion ? 'auto' : 'smooth';

    window.scrollTo({ top: 0, left: 0, behavior });
    this.pageWrapper?.scrollTo({ top: 0, left: 0, behavior });
  }
}

if (!customElements.get('firefly-back-to-top')) {
  customElements.define('firefly-back-to-top', FireflyBackToTop);
}
